import { useMemo } from 'react';

import {
  AssetDataSource,
  ComponentType,
  DataType,
} from '@vgtv/api-client/lib/component';
import type { Component } from '@vgtv/api-client/lib/component';
import type { SvpEpisodeSliderComponent } from '@vgtv/api-client/lib/component/slider';

import {
  isAssetSliderComponent,
  isCategorySliderComponent,
  isContinueWatchingComponent,
  isSvpEpisodeSliderComponent,
} from '../../shared/helpers/componentHelpers';

const useAssetsScheduleProps = (
  componentConfig?: Component | SvpEpisodeSliderComponent
) => {
  const { isLiveScheduleSupported, categoryId, tagId } = useMemo(() => {
    if (!componentConfig) {
      return { isLiveScheduleSupported: false };
    }
    if (
      !(
        isAssetSliderComponent(componentConfig) ||
        isContinueWatchingComponent(componentConfig) ||
        isCategorySliderComponent(componentConfig) ||
        isSvpEpisodeSliderComponent(componentConfig)
      )
    ) {
      return { isLiveScheduleSupported: false };
    }
    if (componentConfig?.data.type === DataType.CATEGORIES) {
      return { isLiveScheduleSupported: false };
    }

    if (
      componentConfig.type !== ComponentType.SLIDER ||
      componentConfig.data.source?.endpoint === AssetDataSource.SVP_EPISODES ||
      componentConfig.data.source?.endpoint === AssetDataSource.SVP_MOST_SEEN ||
      componentConfig.data.preset?.length
    ) {
      return { isLiveScheduleSupported: false };
    }

    const params = componentConfig.data.source?.params?.filter;

    const isLiveAndWasLiveAssetsOnly = params?.streamType?.every((st) =>
      ['live', 'wasLive'].includes(st)
    );

    const categoryId = params?.categoryId;
    const tagId =
      componentConfig.data.source?.endpoint === AssetDataSource.SVP_SEARCH
        ? componentConfig.data.source.params?.filter?.tagsid
        : componentConfig.data.source?.params?.filter?.tag;

    return {
      isLiveScheduleSupported: Boolean(
        (categoryId || tagId) && isLiveAndWasLiveAssetsOnly
      ),
      categoryId,
      tagId,
    };
  }, [componentConfig]);

  return {
    isLiveScheduleSupported,
    categoryId,
    tagId,
  };
};

export { useAssetsScheduleProps };
